// Closing Entry Getters

export const getClosingEntryList = state => {
  return state.closingEntryList
}

export const getClosingEntry = state => {
  return state.closingEntry
}
